import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import LocalNumber from '../LocalNumber'
import {client} from '../../Client';
import Moment from 'moment';

class ReportMovimentiViewEc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: this.props.items,
            rows: [],
            ultimaModificaInfo: {},
            totali: null,
            tableRows: null

        };
        this.loadData = this.loadData.bind(this)
    }

    ordinaMovimenti(items){
        items.sort((a,b) => {
            let ecA = a.estrConto ? a.estrConto.toUpperCase() : '';
            let ecB = b.estrConto ? b.estrConto.toUpperCase() : '';
            if (ecA < ecB) {
                return -1;
            }
            if (ecA > ecB) {
                return 1;
            }
            else {
                let dtA = a.data;
                let dtB = b.data;
                if (dtA < dtB) {
                    return -1;
                }
                if (dtA > dtB) {
                    return 1;
                }
                else {
                    // Ordina per soggetto
                    let soggA = a.soggetto;
                    let soggB = b.soggetto;
                    if (soggA < soggB) {
                        return -1;
                    }
                    if (soggA > soggB) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                }
            }
        })
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.items && nextProps.items && this.state.items.length !== nextProps.items.length){
            this.setState({items: nextProps.items}, ()=>{
                this.loadData();
            });
        }
    }

    loadData() {
        let rows = [];
        let items = this.state.items;
        if (items === undefined){
            if (this.props.onDataCompleted) {
                this.props.onDataCompleted({type:'EC',title:'Report movimenti per EC',rows});
            }
            return null;
        }

        let ultimaModificaInfo = {}

        let totali = {
            'E': {
                impEc:0,
                totEc:0,
                impGg:0,
                totGg:0,
                imp:0,
                tot:0,
            },
            'U': {
                impEc:0,
                totEc:0,
                impGg:0,
                totGg:0,
                imp:0,
                tot:0,
            },
        }

        let tableData = null;
        let tableRows = [];
        let i = 0;
        let ec = null;

        if (items.length > 0){
            this.ordinaMovimenti(items);
            items.forEach((item) => {

                if (item.modificatoIl && (ultimaModificaInfo.modificatoIl === undefined || ultimaModificaInfo.modificatoIl <= item.modificatoIl ))
                {
                    ultimaModificaInfo.modificatoIl = item.modificatoIl;
                    ultimaModificaInfo.modificatoDa = item.modificatoDa;
                }

                item.estrConto = item.estrConto ? item.estrConto : 'Senza Estratto Conto';

                let tabEntrCorrispettivo = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabEntrPagamento = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabUscCorrispettivo = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabUscPagamento = <Table.Cell  textAlign='right'></Table.Cell>;
                let entrCorrispettivo = '';
                let entrOnereprev = '';
                let entrOnerefisc = '';
                let entrAltroimp = '';
                let entrRitenuta = '';
                let entrPagamento = '';
                let uscCorrispettivo = '';
                let uscOnereprev = '';
                let uscOnerefisc = '';
                let uscAltroimp = '';
                let uscRitenuta = '';
                let uscPagamento = '';

                if (item.entrUsc === 'E'){
                    tabEntrCorrispettivo = <Table.Cell  textAlign='right'><LocalNumber value={item.corrispettivo} type="decimal"/></Table.Cell>
                    tabEntrPagamento = <Table.Cell  textAlign='right'><b><LocalNumber value={item.pagamento} type="decimal"/></b></Table.Cell>
                    entrCorrispettivo = item.corrispettivo;
                    entrOnereprev = item.onereprev;
                    entrOnerefisc = item.onerefisc;
                    entrAltroimp = item.altroimp;
                    entrRitenuta = item.ritenuta;
                    entrPagamento = item.pagamento;
                }
                else {
                    tabUscCorrispettivo = <Table.Cell  textAlign='right'><LocalNumber value={item.corrispettivo} type="decimal"/></Table.Cell>
                    tabUscPagamento = <Table.Cell  textAlign='right'><b><LocalNumber value={item.pagamento} type="decimal"/></b></Table.Cell>
                    uscCorrispettivo = item.corrispettivo;
                    uscOnereprev = item.onereprev;
                    uscOnerefisc = item.onerefisc;
                    uscAltroimp = item.altroimp;
                    uscRitenuta = item.ritenuta;
                    uscPagamento = item.pagamento;
                }

                let rowMovimento = (<Table.Row key={i++}>
                    <Table.Cell>{item.idMovimento}</Table.Cell>
                    <Table.Cell><LocalDate data={item.data}/></Table.Cell>
                    <Table.Cell><LocalDate data={item.dataEmissioneDoc}/></Table.Cell>
                    <Table.Cell textAlign="center">{item.nomeDocumento ? 'x' : ''}</Table.Cell>
                    <Table.Cell>{item.soggetto}</Table.Cell>
                    <Table.Cell>{item.causale}</Table.Cell>
                    {tabEntrCorrispettivo}
                    {tabEntrPagamento}
                    {tabUscCorrispettivo}
                    {tabUscPagamento}
                    <Table.Cell>{item.idCommessa ? item.idCommessa.codice : ''}</Table.Cell>
                    <Table.Cell>{item.idPdc.nomeCompleto}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.prevDef}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.annoComp}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.estrConto}</Table.Cell>
                </Table.Row>);
                let rowMovimentoRaw = {
                    id: item.idMovimento,
                    data: item.data,
                    forma: item.forma ? item.forma : '',
                    soggetto: item.soggetto ? item.soggetto : '',
                    causale: item.causale ? item.causale : '',
                    ecorrispettivo: entrCorrispettivo,
                    eonereprev: entrOnereprev,
                    eonerefisc: entrOnerefisc,
                    ealtroimp: entrAltroimp,
                    eritenuta: entrRitenuta,
                    epagamento: entrPagamento,
                    ucorrispettivo: uscCorrispettivo,
                    uonereprev: uscOnereprev,
                    uonerefisc: uscOnerefisc,
                    ualtroimp: uscAltroimp,
                    uritenuta: uscRitenuta,
                    upagamento: uscPagamento,
                    tipoCassa: item.tipoCassa,
                    commessa:item.idCommessa ? item.idCommessa.codice : '',
                    pdc:item.idPdc.nomeCompleto,
                    pd: item.prevDef ? item.prevDef : '',
                    anno:item.annoComp,
                    ec: (item.estrConto && item.estrConto !== 'Senza Estratto Conto') ? item.estrConto : '',
                    saldoImp : 0,
                    saldoTot : 0,
                    sottovoce: '',
                    dataEmissioneDoc: item.dataEmissioneDoc,
                    documentoAllegato: item.nomeDocumento ? true : false
                };


                let headerGg = null;
                let headerEc = null;

                if (item.estrConto !== ec){
                    if (ec !== null){
                        tableRows.push(<Table.Row key={i++}>
                            <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali  <b>{ec}:</b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impEc} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totEc} type="decimal"/></b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impEc} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totEc} type="decimal"/></b></Table.Cell>
                            <Table.Cell colSpan={2} textAlign="right"><b>Saldo (corr/pag):</b> </Table.Cell>
                            <Table.Cell colSpan={3} textAlign="right">
                                <LocalNumber value={totali["E"].impEc - totali["U"].impEc} type="decimal"/>/
                                <b><LocalNumber value={totali["E"].totEc - totali["U"].totEc} type="decimal"/></b>
                            </Table.Cell>
                        </Table.Row>);
                        rows.push({
                            id: '',
                            data: 'TP',
                            causale: 'Entrate/Uscite totali ' + ec,
                            commessa: totali["E"].impEc - totali["U"].impEc,
                            pdc: totali["E"].totEc - totali["U"].totEc,
                            ecorrispettivo: totali["E"].impEc,
                            epagamento: totali["E"].totEc,
                            ucorrispettivo: totali["U"].impEc,
                            upagamento: totali["U"].totEc,
                            saldoImp : totali["E"].impEc - totali["U"].impEc,
                            saldoTot : totali["E"].totEc - totali["U"].totEc,
                            sottovoce: '',

                        });

                        tableRows.push(<Table.Row key={i++}>
                            <Table.Cell colSpan={6} textAlign="right">Totali progressivi </Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["E"].imp} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].tot} type="decimal"/></b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["U"].imp} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].tot} type="decimal"/></b></Table.Cell>
                            <Table.Cell colSpan={2} textAlign="right"><b>Saldo (corr/pag):</b> </Table.Cell>
                            <Table.Cell colSpan={3} textAlign="right">
                                <LocalNumber value={totali["E"].imp - totali["U"].imp} type="decimal"/>/
                                <b><LocalNumber value={totali["E"].tot - totali["U"].tot} type="decimal"/></b>
                            </Table.Cell>
                        </Table.Row>);
                        rows.push({
                            id: '',
                            data: 'TF',
                            causale: 'Totali progressivi',
                            commessa: totali["E"].imp - totali["U"].imp,
                            pdc: totali["E"].tot - totali["U"].tot,
                            ecorrispettivo: totali["E"].imp,
                            epagamento: totali["E"].tot,
                            ucorrispettivo: totali["U"].imp,
                            upagamento: totali["U"].tot,
                            saldoImp : totali["E"].imp - totali["U"].imp,
                            saldoTot : totali["E"].tot - totali["U"].tot,
                            sottovoce: 'Totali progressivi',
                        });

                        totali["E"]["impEc"] = 0;
                        totali["E"]["totEc"] = 0;
                        totali["U"]["impEc"] = 0;
                        totali["U"]["totEc"] = 0;
                    }
                    ec = item.estrConto;
                    headerEc = item.estrConto;
                }

                if (headerGg){
                    tableRows.push(headerGg);
                }
                if (headerEc){
                    tableRows.push(<Table.Row key={i++}>
                        <Table.Cell colSpan={15}><h3>{headerEc}</h3></Table.Cell>
                    </Table.Row>);
                    rows.push({
                        id: '',
                        data: 'H1',
                        forma: headerEc,
                    });
                }

                tableRows.push(rowMovimento);
                rows.push(rowMovimentoRaw);

                totali[item.entrUsc ]["impEc"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["totEc"] += Number.parseFloat(item.pagamento);
                totali[item.entrUsc ]["impGg"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["totGg"] += Number.parseFloat(item.pagamento);
                totali[item.entrUsc ]["imp"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["tot"] += Number.parseFloat(item.pagamento);
            });

            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali  <b>{ec}:</b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impEc} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totEc} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impEc} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totEc} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={2} textAlign="right"><b>Saldo:</b></Table.Cell>
                <Table.Cell colSpan={3} textAlign="right"><b><LocalNumber value={totali["E"].totEc - totali["U"].totEc} type="decimal"/></b></Table.Cell>
            </Table.Row>);
            rows.push({
                id: '',
                data: 'TP',
                causale: 'Entrate/Uscite totali ' + ec,
                commessa: totali["E"].impEc - totali["U"].impEc,
                pdc: totali["E"].totEc - totali["U"].totEc,
                ecorrispettivo: totali["E"].impEc,
                epagamento: totali["E"].totEc,
                ucorrispettivo: totali["U"].impEc,
                upagamento: totali["U"].totEc,
                saldoImp : totali["E"].impEc - totali["U"].impEc,
                saldoTot : totali["E"].totEc - totali["U"].totEc,
                sottovoce: '',
            });

            tableRows.push(<Table.Row key={i++}>
                <Table.Cell className="ui" style={{backgroundColor: "#EEEEEE"}} colSpan={15}><h2>Totali generali</h2></Table.Cell>
            </Table.Row>);
            rows.push({
                id: '',
                data: 'H1',
                forma: 'Totali Generali',
            });

            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right"><b>Entrate/Uscite totali </b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].imp} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].tot} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].imp} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].tot} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={2} textAlign="right"><h4>Totale estratto conto:</h4></Table.Cell>
                <Table.Cell colSpan={3} textAlign="right">
                    <h4><LocalNumber value={totali["E"].tot - totali["U"].tot} type="decimal"/></h4>
                </Table.Cell>
            </Table.Row>);
            rows.push({
                id: '',
                data: 'TF',
                causale: 'Entrate/Uscite totali ',
                commessa: totali["E"].imp - totali["U"].imp,
                pdc: totali["E"].tot - totali["U"].tot,
                ecorrispettivo: totali["E"].imp,
                epagamento: totali["E"].tot,
                ucorrispettivo: totali["U"].imp,
                upagamento: totali["U"].tot,
                saldoImp : totali["E"].imp - totali["U"].imp,
                saldoTot : totali["E"].tot - totali["U"].tot,
                sottovoce: '',
            });

            let ultimaModificaText = null;
            if (ultimaModificaInfo && ultimaModificaInfo.modificatoDa && ultimaModificaInfo.modificatoIl){
                ultimaModificaText = <div className="right aligned right floated column">Ultima modifica ai movimenti selezionati eseguita il <LocalDate data={ultimaModificaInfo.modificatoIl}/> alle ore <LocalTime data={ultimaModificaInfo.modificatoIl}/> da {ultimaModificaInfo.modificatoDa.username}</div>
            }

            if (this.props.onDataCompleted) {
                this.props.onDataCompleted({type:'EC',title:'Report movimenti per EC',rows, ultimaModificaInfo});
            }
        }
        this.setState({
            ultimaModificaInfo: ultimaModificaInfo,
            totali: totali,
            rows: rows,
            tableRows: tableRows
        });
    }

    render() {
        let rows = this.state.rows;
        let tableData = null;

        if (rows.length > 0 && this.props.viewData){
            let ultimaModificaText = null;
            if (this.state.ultimaModificaInfo && this.state.ultimaModificaInfo.modificatoDa && this.state.ultimaModificaInfo.modificatoIl){
                ultimaModificaText = <div className="right aligned right floated column">Ultima modifica ai movimenti selezionati eseguita il <LocalDate data={this.state.ultimaModificaInfo.modificatoIl}/> alle ore <LocalTime data={this.state.ultimaModificaInfo.modificatoIl}/> da {this.state.ultimaModificaInfo.modificatoDa.username}</div>
            }

            tableData = (
                <div className="ep-outer-table">
                    <div className="ep-inner-scrollable-table">

                        <Table id="report_movimenti" celled compact={true} className="small">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center" >
                                        Id
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Data
                                    </Table.HeaderCell>
                                    <Table.HeaderCell  textAlign="center">
                                        Dt emis. doc.
                                    </Table.HeaderCell>
                                    <Table.HeaderCell  textAlign="center">
                                        Allegato
                                    </Table.HeaderCell>
                                    <Table.HeaderCell  textAlign="center">
                                        Soggetto
                                    </Table.HeaderCell>
                                    <Table.HeaderCell  textAlign="center">
                                        Causale
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" colSpan={2}>
                                        Entrate
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" colSpan={2}>
                                        Uscite
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Commessa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        PDC
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        P/D
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Anno Comp
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        E/C
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={6} >

                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Corrispettivo
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Pagamento
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Corrispettivo
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" >
                                        Pagamento
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={5} >

                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.tableRows}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell colSpan={15}>  </Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                        <div className="ui two columns grid">
                            <div className="column">Stampa eseguita il <LocalDate data={Moment().format("YYYY-MM-DD")}/> alle ore <LocalTime data={Moment().format(Moment().ISO_8601)}/> da {client.getCurrentUser().nome}</div>
                            {ultimaModificaText}
                        </div>
                    </div>
                </div>
            )
        }
        else if (this.props.viewData === false){
            tableData = (
                <div className="ui text container">
                    <h3 className="first"><i className="search icon"></i> Nessun dato visualizzato</h3>
                    <p>
                        Se vuoi visualizzare la tabella con i dati, modifica il flag: <b>Mostra Dati<i className="arrow up icon"></i></b>
                    </p>
                </div>
            );
        }
        return tableData
    }
}




export default ReportMovimentiViewEc;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportMovimentiViewEc.js
 **/